import type { FaireProductEntity } from "../../entity_types/product";

export const p_etv28e5jp4: FaireProductEntity = {
  token: "p_etv28e5jp4",
  type: "product",
  name: "Xmas Kitties Christmas greeting card",
  brandToken: "b_4cu4uycf",
  brandName: "Red Cap Cards",
  imageUrl:
    "https://cdn.faire.com/fastly/751018e80e89350e128b20842b0e8b57e585d6a53e4f3bf25ecec75dbffc1866.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/d479cee6769f8b668a08e35d1c8d2e81feb0283475a8b3a5cc6bf1cd0961407a.jpeg",
  ],
  priceDollars: 2.75,
  description:
    "Blank inside. 100lb heavyweight card stock. Offset printed and foil stamped. 4.25 x 5.5 inches. Illustrated by Kate Pugsley. Printed by Red Cap Cards in Los Angeles, California, USA, on recycled paper.\nAvailable as both single cards and pre-packaged boxed cards.\n• Each single card comes with an envelope and a cellophane sleeve.\n• Boxed sets are 8 cards with envelopes and are to be sold as packaged, not to be re-sold as individual cards.",
  tags: [],
  msrpDollars: 5.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:22.660Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
